import classNames from "classnames/dedupe";
import type { ReactElement } from "react";
import { cloneElement } from "react";

export const adornmentWithClassName = (
  component?: ReactElement,
  validationClasses?: string,
  className?: string,
) => {
  if (!component) return null;

  return cloneElement(component, {
    className: classNames(
      (component.props as { className?: string }).className,
      validationClasses,
      className,
    ),
  } as { className: string });
};
